import styled, { css } from 'styled-components';
import { Button } from '#atoms';

interface LabelButtonProps {
  isActive?: boolean;
}

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
`;

export const LabelButton = styled(Button)<LabelButtonProps>`
  height: 100%;
  padding: 10px;

  ${({ isActive }) =>
    isActive &&
    css`
      background-color: ${({ theme }) => theme.palette.brand400} !important;
      color: #fff;
    `}
`;
